import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/config";

export default function AdditionalInfoModal({
  isOpen,
  onClose,
  onSubmit,
  po,
  additionalInfo,
  setAdditionalInfo,
  error
}) {
  const [cannedMessages, setCannedMessages] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    const unsubscribe = onSnapshot(collection(db, "canned_messages"), (snapshot) => {
      const list = [];
      snapshot.forEach((doc) => {
        list.push({ id: doc.id, ...doc.data() });
      });
      list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      setCannedMessages(list);
    });
    return () => unsubscribe();
  }, [isOpen]);

  if (!isOpen || !po) return null;

  const handleSelectCanned = (e) => {
    const selectedId = e.target.value;
    if (!selectedId) return;
    const selected = cannedMessages.find(m => m.id === selectedId);
    if (selected) {
      setAdditionalInfo(selected.message);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "500px" }}>
        <div className="modal-header">
          <h3>Edit Note to Customer</h3>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <form onSubmit={onSubmit}>
          {error && (
            <div className="login-error-alert animate-fade-in" style={{ marginBottom: "1rem" }}>
              {error}
            </div>
          )}
          <div className="form-group" style={{ marginBottom: "1rem" }}>
            <label className="form-label" htmlFor="cannedMessageSelect">Canned Messages:</label>
            <select
              id="cannedMessageSelect"
              className="form-input"
              onChange={handleSelectCanned}
              defaultValue=""
            >
              <option value="">-- Select a Canned Message --</option>
              {cannedMessages.map(msg => (
                <option key={msg.id} value={msg.id}>
                  {msg.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="additionalInfoField">Note to Customer:</label>
            <textarea
              id="additionalInfoField"
              className="form-input"
              rows="6"
              placeholder="Enter details to be displayed on quotes/bids..."
              value={additionalInfo}
              onChange={(e) => setAdditionalInfo(e.target.value)}
              style={{ resize: "vertical", minHeight: "120px" }}
              autoFocus
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem", marginTop: "1.5rem" }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save Note
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
